@file:OptIn(InternalResourceApi::class)

package jsonize.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/jsonize.sharedui.generated.resources/"

@delegate:ResourceContentHash(1_365_796_751)
internal val Res.drawable.ic_cyclone: DrawableResource by lazy {
      DrawableResource("drawable:ic_cyclone", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_cyclone.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-873_566_858)
internal val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-990_425_980)
internal val Res.drawable.ic_light_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_light_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_light_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(823_283_672)
internal val Res.drawable.ic_rotate_right: DrawableResource by lazy {
      DrawableResource("drawable:ic_rotate_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_rotate_right.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_815_451_753)
internal val Res.drawable.kotlin_svgrepo_com: DrawableResource by lazy {
      DrawableResource("drawable:kotlin_svgrepo_com", setOf(
        ResourceItem(setOf(), "${MD}drawable/kotlin_svgrepo_com.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(689_640_574)
internal val Res.drawable.swift_svgrepo_com: DrawableResource by lazy {
      DrawableResource("drawable:swift_svgrepo_com", setOf(
        ResourceItem(setOf(), "${MD}drawable/swift_svgrepo_com.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-460_599_046)
internal val Res.drawable.typescript_svgrepo_com: DrawableResource by lazy {
      DrawableResource("drawable:typescript_svgrepo_com", setOf(
        ResourceItem(setOf(), "${MD}drawable/typescript_svgrepo_com.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_cyclone", Res.drawable.ic_cyclone)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_light_mode", Res.drawable.ic_light_mode)
  map.put("ic_rotate_right", Res.drawable.ic_rotate_right)
  map.put("kotlin_svgrepo_com", Res.drawable.kotlin_svgrepo_com)
  map.put("swift_svgrepo_com", Res.drawable.swift_svgrepo_com)
  map.put("typescript_svgrepo_com", Res.drawable.typescript_svgrepo_com)
}
